export function or(...args: string[]) {
  if (args.every((arg) => arg.length === 1)) {
    return `[${args.join()}]`
  } else {
    const joinedArgs = args.map((arg) => `(?:${arg})`).join("|")
    return `(?:${joinedArgs})`
  }
}
